module.exports = "<div class=\"container\">\n  <h1 translate>account.section.shipment.tracking.heading</h1>\n  <app-shipment-status [shipment]=\"track\"></app-shipment-status>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shipments/components/track/track.component.html
// module id = ./src/app/modules/shipments/components/track/track.component.html
// module chunks = main